export enum IntegrationProvider {
    BLUEBOX_ONLINE = 'BLUEBOX_ONLINE',
}
